import { AppProviders } from '@/app/providers/AppProviders';
import { RouterProvider } from '@/app/router';
import { MagicControlBridge, isPhoenixOnTopMode } from '@/shared/legacyMagicBridge';

/**
 * Hlavní vstupní bod aplikace.
 * Zapouzdřuje všechny globální providery a router.
 *
 * V Phoenix-On-Top režimu (Phoenix-primary, Magic-embedded) navíc mountuje skrytý
 * <MagicControlBridge>, který drží Magic control iframe a postMessage komunikaci.
 */
export function App() {
  const content = <RouterProvider />;
  return (
    <AppProviders>
      {isPhoenixOnTopMode() ? <MagicControlBridge>{content}</MagicControlBridge> : content}
    </AppProviders>
  );
}
